<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">search</i>
                        </div>
                        <h3 class="card-title ">Visualizar Proposta</h3>
                    </div>
                    <div class="card-body">
                        <div class="row" v-if="form.proposal_status_id != 5">
                            <div v-if="form.invoice_at == null" class="col-sm-2">
                                <router-link id="proposal-invoice" data-original-title title="Faturar Proposta" class="btn btn-block btn-sm btn-primary" tag="button" :to="{'name': 'proposals.invoice', params: { 'id' : form.id }}">
                                             <md-icon>confirmation_number</md-icon>
                                    Faturar
                                </router-link>
                            </div>
                            <div class="col-sm-2">
                                <router-link id="proposal-cancel" data-original-title title="Cancelar Proposta" class="btn btn-block btn-sm btn-danger" tag="button" :to="{'name': 'proposals.cancel', params: { 'id' : form.id }}">
                                             <md-icon>cancel</md-icon>
                                    Cancelar
                                </router-link>
                            </div>
                            <div v-if="form.contemplate_at == null" class="col-sm-2">
                                <router-link id="proposal-contemplate" data-original-title title="Contemplar Proposta" class="btn btn-block btn-sm btn-success" tag="button" :to="{'name': 'proposals.contemplate', params: { 'id' : form.id }}">
                                             <md-icon>gavel</md-icon>
                                    Contemplar
                                </router-link>
                            </div>
                            <!-- <div v-if="form.proposal_status_id != 4" class="col-sm-2">
                                <router-link id="proposal-in_default" data-original-title title="Proposta Inadiplente" class="btn btn-block btn-sm btn-warning" tag="button" :to="{'name': 'proposals.in_default', params: { 'id' : form.id }}">
                                             <md-icon>warning</md-icon>
                                    Inadiplente
                                </router-link>
                            </div> -->
                            <div v-if="user.profile.type_profile_id != '5'" class="col-sm-2">
                                <router-link id="proposal-edit" data-original-title title="Editar Proposta" class="btn btn-block btn-sm btn-outline-primary" tag="button" :to="{'name': 'proposals.edit', params: { 'id' : form.id }}">
                                             <md-icon>edit</md-icon>
                                    Editar
                                </router-link>
                            </div>
                            <div class="col-sm-2">
                                <router-link id="proposal-transf-client" data-original-title title="Transferir Cliente" class="btn btn-block btn-sm btn-outline-warning" tag="button" :to="{'name': 'proposals.transf-client', params: { 'id' : form.id }}">
                                             <md-icon>person</md-icon>
                                    T. Cliente
                                </router-link>
                            </div>
                            <div v-if="user.profile.type_profile_id != '4'" class="col-sm-2">
                                <router-link id="proposal-transf-salesman" data-original-title title="Transferir Vendedor" class="btn btn-block btn-sm btn-secondary" tag="button" :to="{'name': 'proposals.transf-salesman', params: { 'id' : form.id }}">
                                             <md-icon>person_outline</md-icon>
                                    T. Vendedor
                                </router-link>
                            </div>
                            <div v-if="user.profile.type_profile_id != '4'" class="col-sm-2">
                                <router-link id="proposal-duplicate" data-original-title title="Duplicar Proposta" class="btn btn-block btn-sm btn-secondary" tag="button" :to="{'name': 'proposals.duplicate', params: { 'id' : form.id,  'administrador_id' : form.administrator.id }}">
                                             <md-icon>file_copy</md-icon>
                                    Duplicar
                                </router-link>
                            </div>
                            <div class="col-sm-2">
                                <button id="proposal-print" class="btn btn-block btn-sm btn-secondary" v-on:click="print">
                                             <md-icon>print</md-icon>
                                    Imprimir
                                </button>
                            </div>
                        </div>
                        <hr />
                        <b-tabs card class="col-sm-12">
                            <b-tab title="Dados do Cliente">
                                <div class="row">
                                    <div class="col-md-4">
                                        <h6 v-if='form.client.cpf_cnpj.length==11' class="card-title">CPF</h6>
                                        <h6 v-else class="card-title">CNPJ</h6>
                                        <p class="card-category">{{ form.client.cpf_cnpj | cpf_cnpj }}</p>
                                    </div>
                                    <div class="col-md-4">
                                        <h6 class="card-title">Nome</h6>
                                        <p class="card-category">{{ form.client.name }}</p>
                                    </div>
                                    <div class="col-md-4"
                                        v-if="form.client.cpf_cnpj.length <= 11">
                                        <h6 class="card-title">Nome da mãe</h6>
                                        <p class="card-category">{{ form.client.mother_name }} </p>
                                    </div>
                                </div>
                                <h3 v-if="form.client.cpf_cnpj.length <= 11" class="info-text">
                                    RG
                                </h3>
                                <h3 v-else class="info-text">
                                    Insc. Estadual
                                </h3>
                                <hr />
                                <div class="row">
                                    <div class="col-md-3">
                                        <h6 class="card-title">Número</h6>
                                        <p class="card-category">{{ form.client.registration_number }}</p>
                                    </div>
                                    <div class="col-md-3">
                                        <h6 class="card-title">Orgão Emissor</h6>
                                        <p class="card-category">{{ form.client.dispatcher_registration_number }}</p>
                                    </div>
                                    <div class="col-md-3">
                                        <h6 class="card-title">Expedição</h6>
                                        <p class="card-category">{{ form.client.shipment_date_registration_number | moment('DD/MM/YYYY') }}</p>
                                    </div>
                                    <div class="col-md-3">
                                        <h6 v-if="form.client.cpf_cnpj.length <= 11" class="card-title">Nascimento</h6>
                                        <h6 v-else class="card-title">Abertura</h6>
                                        <p class="card-category">{{ form.client.date_of_birth | moment('DD/MM/YYYY') }}</p>
                                    </div>
                                </div>
                                <div v-if="form.client.cpf_cnpj.length <= 11" class="row">
                                    <div class="col-md-3">
                                        <h6 class="card-title">Nacionalidade</h6>
                                        <p class="card-category">{{ form.client.nationality }}</p>
                                    </div>
                                    <div class="col-md-3">
                                        <h6 class="card-title">Naturalidade</h6>
                                        <p class="card-category">{{ form.client.naturality }}</p>
                                    </div>
                                    <div class="col-md-2">
                                        <h6 class="card-title">Estado Civil</h6>
                                        <p class="card-category">{{ (marital_status.find(ms => ms === form.client.marital_status) || { text: 'Outros' }).text }}</p>
                                    </div>
                                    <div class="col-md-2">
                                        <h6 class="card-title">Sexo</h6>
                                        <p class="card-category">{{ sexes.find(s => s.value === form.client.sex).text }}</p>
                                    </div>
                                    <div class="col-md-2">
                                        <h6 class="card-title">Valor do Patrimônio</h6>
                                        <p class="card-category">R$ {{ form.client.equity_value | price }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-2">
                                        <h6 class="card-title">Autoriza divulgar dados?</h6>
                                        <p class="card-category">{{ form.client.authorize_disseminate_data?'Sim':'Não' }}</p>
                                    </div>
                                    <div class="col-md-2">
                                        <h6 class="card-title">Pessoa politicamente exposta?</h6>
                                        <p class="card-category">{{ form.client.pessoa_politicamente_exposta?'Sim':'Não' }}</p>
                                    </div>
                                    <div class="col-md-2">
                                        <h6 class="card-title">Possui capacidade econômica/financeira?</h6>
                                        <p class="card-category">{{ form.client.possui_capacidade_economica_financeira?'Sim':'Não' }}</p>
                                    </div>
                                    <div class="col-md-2">
                                        <h6 class="card-title">Reconhece assinatua presente na proposta?</h6>
                                        <p class="card-category">{{ form.client.reconhece_assinatura_presente_proposta?'Sim':'Não' }}</p>
                                    </div>
                                    <div class="col-md-2">
                                        <h6 class="card-title">Não recebi promessa de contemplação?</h6>
                                        <p class="card-category">{{ form.client.nao_recebeu_promessa_contemplacao?'Sim':'Não' }}</p>
                                    </div>
                                    <div class="col-md-2">
                                        <h6 class="card-title">Informar eventuais alterações?</h6>
                                        <p class="card-category">{{ form.client.ciencia_informar_alteracoes_afins?'Sim':'Não' }}</p>
                                    </div>
                                </div>
                                <div id="pessoa-fisica" v-if="form.client.cpf_cnpj.length <= 11">
                                    <h3 class="info-text">
                                        Dados Profissionais
                                    </h3>
                                    <hr />
                                    <div class="row">
                                        <div class="col-md-4">
                                            <h6 class="card-title">Nome da Empresa</h6>
                                            <p class="card-category">{{ form.client.company_name }}</p>
                                        </div>
                                        <div class="col-md-4">
                                            <h6 class="card-title">Profissão</h6>
                                            <p class="card-category">{{ form.client.profession }}</p>
                                        </div>
                                        <div class="col-md-4">
                                            <h6 class="card-title">Salário</h6>
                                            <p class="card-category">R$ {{ form.client.salary | price }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div id="pessoa-juridica" v-else>
                                    <h3 class="info-text">
                                        Dados Empresariais
                                    </h3>
                                    <hr />
                                    <div class="row">
                                        <div class="col-md-4">
                                            <h6 class="card-title">Atividade da Empresa</h6>
                                            <p class="card-category">{{ form.client.activity_name }}</p>
                                        </div>
                                        <div class="col-md-4">
                                            <h6 class="card-title">Faturamento Mensal</h6>
                                            <p class="card-category">R$ {{ form.client.monthly_billing | price }}</p>
                                        </div>
                                        <div class="col-md-4">
                                            <h6 class="card-title">Valor do Patrimônio</h6>
                                            <p class="card-category">R$ {{ form.client.equity_value | price }}</p>
                                        </div>
                                    </div>
                                    <h4 class="info-text">
                                        Sócios
                                    </h4>
                                    <div class="row"
                                        v-for="partner in form.client.partners">
                                        <div class="col-md-4">
                                            <h6 class="card-title">Nome</h6>
                                            <p class="card-category">{{ partner.name }}</p>
                                        </div>
                                        <div class="col-md-4">
                                            <h6 class="card-title">CPF/CNPJ</h6>
                                            <p class="card-category">{{ partner.cpf_cnpj | cpf_cnpj }}</p>
                                        </div>
                                        <div class="col-md-4">
                                            <h6 class="card-title">Participação (%)</h6>
                                            <p class="card-category">{{ partner.participation | price }}</p>
                                        </div>
                                    </div>
                                </div>
                                <h3 class="info-text">
                                    Dados de Contato
                                </h3>
                                <hr />
                                <div class="row">
                                    <div class="col-md-3">
                                        <h6 class="card-title">E-mail</h6>
                                        <p class="card-category">{{ form.client.mail }}</p>
                                    </div>
                                    <div class="col-md-3">
                                        <h6 class="card-title">Telefone Celular</h6>
                                        <p class="card-category">{{ form.client.cell_phone | phone }}</p>
                                    </div>
                                    <div class="col-md-3">
                                        <h6 class="card-title">Telefone Residencial</h6>
                                        <p class="card-category">{{ form.client.home_phone | phone }}</p>
                                    </div>
                                    <div class="col-md-3">
                                        <h6 class="card-title">Telefone Comercial</h6>
                                        <p class="card-category">{{ form.client.commercial_phone | phone }}</p>
                                    </div>
                                </div>
                                <h3 v-if='form.client.bank' class="info-text">
                                    Dados Bancários
                                </h3>
                                <hr v-if='form.client.bank' />
                                <div v-if='form.client.bank' class="row">
                                    <div class="col-md-4">
                                        <h6 class="card-title">Banco</h6>
                                        <p class="card-category">{{ form.client.bank?form.client.bank.name:'Não definido' }}</p>
                                    </div>
                                    <div class="col-md-4">
                                        <h6 class="card-title">Agência</h6>
                                        <p class="card-category">{{ form.client.bank_branch }} - {{ form.client.bank_digit_branch }}</p>
                                    </div>
                                    <div class="col-md-4">
                                        <h6 class="card-title">Número da conta</h6>
                                        <p class="card-category">{{ form.client.account_number }} - {{ form.client.account_digit }}</p>
                                    </div>
                                </div>
                                <h3 class="info-text">
                                    Endereço
                                </h3>
                                <hr />
                                <div class="row">
                                    <div class="col-md-4">
                                        <h6 class="card-title">CEP</h6>
                                        <p class="card-category">{{ form.client_address.cep | cep }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <h6 class="card-title">Endereço</h6>
                                        <p class="card-category">{{ form.client_address.address }}</p>
                                    </div>
                                    <div class="col-md-2">
                                        <h6 class="card-title">Número</h6>
                                        <p class="card-category">{{ form.client_address.number }}</p>
                                    </div>
                                    <div class="col-md-4">
                                        <h6 class="card-title">Bairro</h6>
                                        <p class="card-category">{{ form.client_address.borough }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <h6 class="card-title">Complemento</h6>
                                        <p class="card-category">{{ form.client_address.complement }}</p>
                                    </div>
                                    <div class="col-md-6">
                                        <h6 class="card-title">Cidade</h6>
                                        <p class="card-category">{{ form.client_address.city.name }}/{{ form.client_address.city.state.abbreviation }}</p>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab title="Dados da Proposta">
                                <div class="row">
                                    <div class="col-md-4">
                                        <h6 class="card-title">Número do Contrato</h6>
                                        <p class="card-category">{{ form.physical_proposal }}</p>
                                    </div>
                                    <div class="col-md-4">
                                        <h6 class="card-title">Status</h6>
                                        <p class="card-category">{{ form.proposal_status.name }}</p>
                                    </div>
                                    <div class="col-md-4">
                                        <h6 class="card-title">Vendedor</h6>
                                        <p class="card-category">{{ form.salesman?form.salesman.name:'Não definido' }}</p>
                                    </div>

                                </div>
                                <div class="row">
                                    <div class="col-sm-4">
                                        <h6 class="card-title">Protocolo</h6>
                                        <p class="card-category">{{ form.protocol ? form.protocol : '******' }}</p>
                                    </div>

                                     <div class="col-md-4">
                                        <h6 class="card-title">Classificação</h6>
                                        <p class="card-category">{{ form.type_sale ? form.type_sale.name : 'Não definido' }}</p>
                                    </div>

                                    <div class="col-md-4">
                                        <h6 class="card-title">DT. Lançamento</h6>
                                        <p class="card-category">{{ form.created_at | moment('DD/MM/YYYY [às] HH[h]mm[m]') }}</p>
                                    </div>

                                </div>
                                <div class="row">
                                    <div class="col-sm-4">
                                        <h6 class="card-title">Indicador de ficha</h6>
                                        <p class="card-category">{{ form.user_indicator ? form.user_indicator.name : 'Não definido' }}</p>
                                    </div>
                                    <div class="col-sm-4">
                                        <h6 class="card-title">Tipo da Venda</h6>
                                        <p class="card-category">{{ form.type_sale_new ? form.type_sale_new : '******' }}</p>
                                    </div>
                                </div>
                                <hr />
                                <div class="row">
                                    <div class="col-md-4">
                                        <h6 class="card-title">Administradora</h6>
                                        <p class="card-category">{{ form.administrator?form.administrator.name:'Não definido' }}</p>
                                    </div>
                                    <div class="col-md-4">
                                        <h6 class="card-title">Opção para Plano Simples</h6>
                                        <p class="card-category">{{ form.option_plan ? optionPlans.find(p => p.id === form.option_plan).name : 'Não definido' }}</p>
                                    </div>
                                    <div class="col-md-4">
                                        <h6 class="card-title">Plano</h6>
                                        <p class="card-category">{{ form.plan?form.plan.name:'Não definido' }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4">
                                        <h6 class="card-title">Tipo do Grupo</h6>
                                        <p class="card-category">{{ form.type_group?form.type_group.name:'Não definido' }}</p>
                                    </div>

                                    <div class="col-md-4">
                                        <h6 class="card-title">Grupo</h6>
                                        <p class="card-category">{{ form.group?form.group.name:'Não definido' }}</p>
                                    </div>

                                    <div class="col-md-4">
                                        <h6 class="card-title">Cota</h6>
                                        <p class="card-category">{{ form.quota }}</p>
                                    </div>

                                </div>
                                <div class="row">
                                     <div class="col-md-4">
                                        <h6 class="card-title">Data da Primeira Assembleia</h6>
                                        <p class="card-category">{{ form.first_meeting_at | moment('DD/MM/YYYY') }}</p>
                                    </div>

                                    <div class="col-md-4">
                                        <h6 class="card-title">Data da próxima Assembleia</h6>
                                        <p class="card-category">{{ form.meeting_at | moment('DD/MM/YYYY') }}</p>
                                    </div>
                                </div>
                                <hr />
                                <div class="row">
                                    <div class="col-md-8">
                                        <h6 class="card-title">Bem</h6>
                                        <p class="card-category">{{ form.model?(form.model.manufacturer.name + ' - ' + form.model.name):'Não definido' }}</p>
                                    </div>
                                    <div class="col-md-4">
                                        <h6 class="card-title">Combustível</h6>
                                        <p class="card-category">{{ form.fuel?form.fuel.name:'Não definido' }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4">
                                        <h6 class="card-title">Motivo da Aquisição</h6>
                                        <p class="card-category">{{ form.reason_acquisition }}</p>
                                    </div>
                                    <div class="col-md-4">
                                        <h6 class="card-title">Condição</h6>
                                        <p class="card-category">{{ form.condition }}</p>
                                    </div>
                                    <div class="col-md-4">
                                        <h6 class="card-title">Formação</h6>
                                        <p class="card-category">{{ form.formation }}</p>
                                    </div>
                                </div>
                                <hr />
                                <div class="row">
                                    <div class="col-md-4">
                                        <h6 class="card-title">Taxa Administrativa</h6>
                                        <p class="card-category">{{ form.administrate_tax | percent }} %</p>
                                    </div>
                                    <div class="col-md-4">
                                        <h6 class="card-title">Seguro de Vida</h6>
                                        <p class="card-category">{{ form.life_insurance | percent }} %</p>
                                    </div>
                                    <div class="col-md-4">
                                        <h6 class="card-title">Fundo de Reserva</h6>
                                        <p class="card-category">{{ form.reserve_fund | percent }} %</p>
                                    </div>
                                </div>
                                <hr />
                                <div class="row">
                                    <div class="col-md-4">
                                        <h6 class="card-title">Valor da Carta</h6>
                                        <p class="card-category">R$ {{ form.value | price }}</p>
                                    </div>
                                    <div class="col-md-4">
                                        <h6 class="card-title">Valor da Parcela</h6>
                                        <p class="card-category">R$ {{ form.plot_amount | price }}</p>
                                    </div>
                                    <div class="col-md-4">
                                        <h6 class="card-title">Quant. Parcelas</h6>
                                        <p class="card-category">{{ form.number_installments }}</p>
                                    </div>
                                </div>
                                <hr />
                                <div class="row">
                                    <div class="col-md-4">
                                        <h6 class="card-title">Mídia</h6>
                                        <p class="card-category">{{ form.medias }}</p>
                                    </div>
                                    <div class="col-md-4">
                                        <h6 class="card-title">Data da Venda</h6>
                                        <p class="card-category">{{ form.sale_at | moment('DD/MM/YYYY') }}</p>
                                    </div>
                                    <div class="col-md-4">
                                        <h6 class="card-title">Data Alocação</h6>
                                        <p class="card-category">{{ form.deployment_at | moment('DD/MM/YYYY') }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <h6 class="card-title">Tipos de Pagamento</h6>
                                        <ul>
                                            <li v-for="payment in form.proposal_payments"
                                                :key="payment.id">{{ payment.name }}</li>
                                        </ul>
                                    </div>
                                </div>
                                <div id="contemplacao" v-if="form.contemplate_at != null">
                                    <br />
                                    <h5 class="info-text">Dados da contemplação</h5>
                                    <hr />
                                    <div class="row">
                                        <div class="col-md-2">
                                            <h6 class="card-title">Veículo Novo</h6>
                                            <p class="card-category">{{ form.vehicle_is_new ? 'Sim' : 'Não' }}</p>
                                        </div>
                                        <div class="col-md-2">
                                            <h6 class="card-title">Taxa de alienação interna</h6>
                                            <p class="card-category">{{ form.disposal_fee_is_internal ? 'Sim' : 'Não' }}</p>
                                        </div>
                                        <div class="col-md-2">
                                            <h6 class="card-title">Pagou o boleto</h6>
                                            <p class="card-category">{{ form.paid_billet ? 'Sim' : 'Não' }}</p>
                                        </div>
                                        <div class="col-md-2">
                                            <h6 class="card-title">Data Alocação</h6>
                                            <p class="card-category">{{ form.contemplate_at | moment('DD/MM/YYYY') }}</p>
                                        </div>
                                        <div class="col-md-4">
                                            <h6 class="card-title">Tipo da Contemplação</h6>
                                            <p class="card-category">{{ form.type_contemplation == 'L' ? 'Lance' : 'Sorteio' }}</p>
                                        </div>
                                    </div>
                                </div>
                                <h3 class="info-text">
                                    Observações
                                </h3>
                                <hr />
                                <div class="row">
                                    <div class="col-md-12" v-html="form.observations"></div>
                                </div>
                                <div
                                    v-if="form.proposal_observations && form.proposal_observations.length > 0">
                                    <h3 class="info-text">
                                        Contatos (Pós Venda)
                                    </h3>
                                    <hr />
                                    <div class="row"
                                        v-for="(observation, index) in form.proposal_observations"
                                        :key="index">
                                        <div class="col-12">
                                            <div class="form-group bmd-form-group">
                                                <label>{{ observation.user.name }}({{ observation.user.username }}) {{ observation.created_at | moment('DD/MM/YYYY HH:mm:ss') }} - {{ observation.text }}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h3 class="info-text">
                                    Documentos
                                </h3>
                                <hr />
                                <div class="row">
                                    <div class="col-md-12">
                                        <show-documents :documents="form.documents"/>
                                    </div>
                                </div>
                                <h3 class="info-text">
                                    Parcelas
                                </h3>
                                <hr />
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="table-responsive">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th class="text-center">Ordem</th>
                                                        <!--
                                                        <th class="text-center">Comissão</th>
                                                        <th class="text-center">Estorno</th>
                                                        <th class="text-center">R$ Comissão</th>
                                                        !-->
                                                        <th class="text-center">R$ Parcela</th>
                                                        <th class="text-center">R$ Pago</th>
                                                        <th class="text-center">Data Vencimento</th>
                                                        <th class="text-center">Data Pagamento</th>
                                                        <th class="text-center">Ação</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="form.installments.length > 0" v-for="(installment, index) in form.installments" :key="installment.id">
                                                        <td class="text-center">
                                                            {{ installment.order }}
                                                <md-icon class="text-blue" v-if="installment.contacted" title="Contato com o cliente realizado!">check</md-icon>
                                                </td>
                                                <!--
                                                <td class="text-center">{{ installment.commision | price }}%</td>
                                                <td class="text-center">{{ installment.commission_reversal | price }}%</td>
                                                <td class="text-center" v-if="form.proposal_status_id != 5 && installment.pay_at">R$ {{ (installment.commision * form.value) / 100 | price }}</td>
                                                <td class="text-center" v-else-if="form.proposal_status_id != 5 && installment.reversal_at">
                                                    R$
                                                    <span v-if="index == 0">{{ calcIfCommissionDefault(form.value, form.administrator, installment.commision, installment.commission_reversal) | price }}</span>
                                                    <span v-else>{{ ((installment.commision * form.value) / 100) - ((installment.commission_reversal * form.value) / 100) | price }}</span>
                                                </td>
                                                <td class="text-center" v-else>R$ {{ 0 | price}}</td>
                                                -->
                                                <td class="text-center">R$ {{ installment.price | price }}</td>
                                                <td class="text-center">R$ {{ sumPays(installment.pays) | price }}</td>
                                                <td class="text-center">{{ installment.due_at | moment('DD/MM/YYYY') }}</td>

                                                <td class="text-center" v-if="installment.reversal_at">
                                                    Estornada em {{ installment.reversal_at | moment('DD/MM/YYYY') }}
                                                </td>
                                                <td class="text-center" v-else-if="installment.pay_at">
                                                    {{ installment.pay_at | moment('DD/MM/YYYY') }}
                                                </td>
                                                <td class="text-center" v-else>
                                                    Pendente
                                                </td>
                                                <td class="td-actions text-right">
                                                <router-link data-original-title v-if="form.proposal_status_id != 5 && installment.pay_at != null && installment.reversal_at == null" title="Estornar Parcela" class="btn btn-just-icon btn-round btn-danger btn-link" tag="md-button" :to="{'name': 'proposals.reverse-pay-installment', params: { 'id' : form.id, 'installment': installment.id }}">
                                                    <md-icon>money_off</md-icon>
                                                </router-link>
                                                <router-link data-original-title v-if="form.proposal_status_id != 5 && (installment.pay_at == null || installment.reversal_at != null)" title="Pagar Parcela" class="btn btn-just-icon btn-round btn-success btn-link" tag="md-button" :to="{'name': 'proposals.pay-installment', params: { 'id' : form.id, 'installment': installment.id }}">
                                                    <md-icon>attach_money</md-icon>
                                                </router-link>
                                                <router-link data-original-title v-if="form.proposal_status_id != 5" title="Editar Parcela" class="btn btn-just-icon btn-round btn-primary btn-link" tag="md-button" :to="{'name': 'proposals.edit-parcel', params: { 'id' : form.id, 'installment': installment.id }}">
                                                    <md-icon>edit</md-icon>
                                                </router-link>
                                                <md-button v-if="form.proposal_status_id != 5 && installment.pay_at == null" title="Imprimir Parcela" class="btn btn-just-icon btn-round btn-info btn-link">
                                                    <md-icon>print</md-icon>
                                                </md-button>
                                                </td>
                                                </tr>
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td colspan="7">Valor Pendente</td>
                                                        <td class="text-center text-danger">R$ {{ sum(form.installments, 1) | price }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="7">Valor Pago</td>
                                                        <td class="text-center text-info">R$ {{ sum(form.installments, 2) | price }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="7">Valor Total</td>
                                                        <td class="text-center text-success">R$ {{ sum(form.installments) | price }}</td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                    <div class="card-footer">
                        <form-buttons
                            v-bind:toBackAuto="true" />
                    </div>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
    import ShowDocuments from '@/components/elements/ShowDocuments'
    import Vue from 'vue';
    export default {
        components: {
            'show-documents': ShowDocuments
        },
        computed: {
            form: {
                get() {
                    return this.$store.state.proposals.item;
                },
                set(_form) {

                }
            },
            user: {
                get() {
                    return this.$store.state.auth.user;
                },
                set(_user) {

                }
            }
        },
        created() {
            var months = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outobro", "Novembro", "Dezembro"];
            var now = new Date();
            this.now = now.getDate() + " de " + months[now.getMonth()] + " de " + now.getFullYear();
            this.getDataProposal();
        },
        data() {
            return {
                marital_status: [
                    {value: '', text: 'Selecione uma opção'},
                    {value: 'S', text: 'Solteiro'},
                    {value: 'C', text: 'Casado'},
                    {value: 'D', text: 'Divorciado'},
                    {value: 'V', text: 'Viúvo'},
                    {value: 'U', text: 'União Estável'},
                    {value: 'O', text: 'Outros'}
                ],
                now: '',
                optionPlans: [
                    {id: null, name: 'Não definido'},
                    {id: 'S7', name: 'Plano Simples (67%)'},
                    {id: 'S', name: 'Plano Simples (75%)'},
                    {id: 'I', name: 'Plano Integral (100%)'}
                ],
                sexes: [
                    {value: '', text: 'Selecione uma opção'},
                    {value: 'F', text: 'Feminino'},
                    {value: 'M', text: 'Masculino'},
                ],
            };
        },
        watch : {
            '$route.params.id' : {
                deep: true,
                handler(newTo, oldFrom){
                    if(oldFrom !== newTo)
                        this.getDataProposal();
                }
            },
        },
        methods: {
             getImg(_logo) {
                return 'data: ' + _logo.contentType + ';base64,' + _logo.content;
            },
            calcIfCommissionDefault: (_value, _administrator, _commission, _commissionReversal) => {
                var commission = (_value * _commission) / 100;
                if (_commissionReversal > 0) {
                    commission -= (_value * _commissionReversal) / 100;
                } else {
                    if (_administrator.commission_reversal_default > 0) {
                        commission -= (_value * _administrator.commission_reversal_default) / 100;
                    } else {
                        commission = 0;
                    }
                }

                return commission;
            },
            sumPays(_pays){
                let _sum = 0;
                if(_pays != undefined)
                {
                    _pays.forEach( (obj, _key) => {
                        _sum += Number(obj.value)
                    });
                }

                return _sum;
            },
            async getDataProposal() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('proposals/get', self.$route.params.id);

                response.then(function () {
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
            sum(_installments, _type) {
                var total = 0, self=this;
                switch (_type) {
                    case 1:
                        _installments.forEach(function (_installment, _key) {
                            if (_installment.pay_at === null) {
                                total += _installment.price;
                            }
                        });
                        break;

                    case 2:
                        _installments.forEach(function (_installment, _key) {
                            if (_installment.pay_at !== null)
                            {
                                total += self.sumPays(_installment.pays);
                            }
                        });
                        break;

                    default:
                        _installments.forEach(function (_installment, _key) {
                            total += _installment.price;
                        });
                }

                return total;
            },
            print() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('proposals/print', self.$route.params.id);

                response.then(function (_downloadPdf) {
                    let filename = 'contract.pdf'
                    let blob = new Blob([_downloadPdf], {type: 'application/pdf'});

                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = filename
                    link.click();

                    self.$root.$emit("onLoading")
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            }
        }
    };
</script>
<style scoped="">
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>